import React from "react";
import { DetailsSection } from "components/DetailsSection";
import { MapToLine } from "helpers/Helpers";
import { WorkDetails } from "generated/types/types";
import { JobsIcon } from "components/icons/Icons";
import { useTranslation } from "react-i18next";

type Props = {
    workDetails: WorkDetails;
};

/**
 * A component for displaying a list of the types of work associated with the booking, as rendered by the server.
 * This includes some types of work that aren't yet supported by the microsite booking pages, such as wheel alignment work.
 */
export const WorkDetailsSection: React.FC<Props> = props => {
    const { t } = useTranslation();
    const workDescriptions = props.workDetails.workDescriptions.map(work => work[0].toUpperCase() + work.slice(1).toLowerCase());
    return (
        <DetailsSection
            key="detailsSection"
            iconComponent={JobsIcon}
            heading={t("work_details_section_work_details")}
            lines={[
                ...MapToLine(workDescriptions),
                ...MapToLine(props.workDetails.userInvestigationLines),
                ...MapToLine(props.workDetails.motRequired ? ["MOT required"] : []),
                ...MapToLine(props.workDetails.tyreWorkDescription ? [props.workDetails.tyreWorkDescription] : []),
                ...MapToLine(props.workDetails.wheelAlignmentRequired ? ["Wheel alignment required"] : []),
            ]}
        />
    );
};
